// extracted by extract-css-chunks-webpack-plugin
module.exports = {"availableRewardsWrapper":"DgOl0","carouselTrack":"_0fayN","carouselArrow":"JfY5d"};